/**
 * Mobile Portal Help – field ops support
 */

import { Phone, Mail, MessageSquare } from 'lucide-react';

const contactMethods = [
  { icon: Phone, label: 'Phone', value: '+264 61 123 4567', description: 'Mon–Fri 8am–5pm' },
  { icon: Mail, label: 'Email', value: 'support@ketchupsolutions.com', description: 'Response within 24 hours' },
  { icon: MessageSquare, label: 'Live Chat', value: 'In-app', description: 'Real-time support' },
];

export default function Help() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Help & Support</h1>
        <p className="text-muted-foreground">Field ops: mobile units, ATMs, activity</p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {contactMethods.map((m) => (
          <div key={m.label} className="rounded-xl border bg-card p-6">
            <m.icon className="h-8 w-8 text-primary mb-3" />
            <h3 className="font-semibold text-sm">{m.label}</h3>
            <p className="text-sm font-medium mt-1">{m.value}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{m.description}</p>
          </div>
        ))}
      </div>

      <div className="rounded-xl border bg-card p-6">
        <h3 className="font-semibold mb-2">Mobile Portal (PRD §6)</h3>
        <p className="text-sm text-muted-foreground">
          Field ops use this portal to view mobile units and ATMs, and to log activity (inspection, repair, service) and
          maintenance/replenishment. Same backend as Ketchup Portal; this UI is for field use.
        </p>
      </div>
    </div>
  );
}
